// 获取日期的月份和日期，例如：2021-01-01 00:00:00 => 01-01
export const getMonthAndDay = (date: string): string => {
  const [, month, day] = date.replace(" 00:00:00", "").split("-");
  return `${month}-${day}`;
};

// 获取日期，例如：2021-02-01 00:00:00 => 01
export const getDay = (date: string): string => {
  const [, , day] = date.replace(" 00:00:00", "").split("-");
  return day;
};

// 获取日期对应的星期几相对于星期一的偏移，例如：2023-01-01 00:00:00 为星期天 => 偏移 6
export const getDayOffset = (date: string): number => {
  const week = new Date(date).getDay();
  return week === 0 ? 6 : week - 1;
};

// 获取当前日期相对于某一日期期间的偏移文本
// 例如: start 为 2021-01-10 00:00:00，end 为 2021-01-30 00:00:00
// case: 今天是 start 至 end 中的某一日期，则返回 “进行中”
// case: 今天是 end 之后的某一日期，则返回 “已结束”
// case: 今天是 start 之前的某一日期，则返回 “倒计时: x天”
export const getOffsetText = (start: string, end: string): string => {
  const now = new Date().getTime();
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();
  if (now < startTime) {
    return `活动倒计时: ${Math.ceil(
      (startTime - now) / 1000 / 60 / 60 / 24
    )}天`;
  }
  if (now > endTime) {
    return "活动已结束";
  }
  return "活动进行中";
};

// 判断当前时间是否已超过给定时间
export const isExpired = (date: string): boolean => {
  const now = new Date().getTime();
  const time = new Date(date).getTime();
  return now > time;
};
